export default {
  data () {
    return {
      tableCols: [ // 节目集发布表头
        { type: 'selection', width: 55 },
        { prop: 'name', label: '节目名称' },
        { prop: 'category', label: '一级分类' },
        { prop: 'sndCategory', label: '二级分类' },
        { prop: 'seriesNo', label: '集号' },
        { prop: 'updateBy', label: '操作人' },
        { prop: 'updateTime', label: '更新时间', type: 'slot' }
      ]
    }
  },
  computed: {
    searchData () {
      return [
        { prop: 'name', type: 'input', label: '节目名称：', placeholder: '请输入节目名称', clearable: true, col: [3, 3, 3] },
        {
          prop: 'category',
          label: '分类',
          type: 'select',
          options: this.categoryList,
          clearable: true,
          change: this.selectChangeCategory
        },
        {
          prop: 'sndCategory',
          label: '二级分类',
          type: 'select',
          disabled: false, // this.sndCategoryDisabled,
          clearable: true,
          options: this.sndCategoryList
        },
        {
          prop: 'updateTimeArr',
          label: '更新时间：',
          type: 'slot'
        },
        { prop: 'search', type: 'slot', label: '', col: [3, 3, 3] }
      ]
    }
  }
}
